// var $ = require('jquery')

// This is your plugin object. It can be exported to be used anywhere.
const MyI18NLoader = {

  name: 'I18N',
  install(Vue, options) {
    // We call Vue.mixin() here to inject functionality into all components.
    // var cmp = this
    Vue.i18n.add('de', this.data.translationsDe)
    Vue.i18n.add('en', this.data.translationsEn)
    Vue.i18n.set('de')

    /*
    var keys = Object.keys(this.data.translationsDe);
    Vue.prototype.$api.debug(keys)
    var html = ''
    for (var i in keys) {
      var item = keys[i]
      var vl = this.data.translationsDe[item]
      vl = vl.replace("<br>", "")
      html += '\r\n' + item + ";\"" + vl+"\""
    }
    var $container = $("body");
    $container.append('<div id="answerdiv">\n' + html + '\n</div>');

*/

    /*
    if (Vue.config.I18N_LOAD) {
      Vue.prototype.$api.debug('Load i18n ' + Vue.config.I18N_APP_NAME)
      $.getJSON(Vue.config.host + '/I18N/export/' + Vue.config.I18N_APP_NAME, function (data) {
        Vue.i18n.add('de', data.localeDE)
        Vue.i18n.add('en', data.localeEN)
        Vue.i18n.set('de')
        if (cmp.starter) {
          cmp.starter()
        }
      })
    }
    */

    // set the start locale to use
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted() {
      }
    })
  },
  data: {
    'translationsDe': {
      'SEARCH_TEXT_ERROR_1000': 'Es sind zu viele Trefferlisten spalten konfiguriert',
      'SEARCH_TITLE_ERROR_1000': 'Fehler in Suchkonfiguration',
      'BTN_KONFIGURATION': 'Konfiguration',
      'TITLE_SEARCH': 'Suche',
      'TITLE_CONFIG_MODULE_SEARCH': 'Ankerbanksuche',
      'TITLE_CONFIG_MODULE_PEERGROUP': 'Peergroupsuche',
      'DIALOG_TEXT_ERROR_DOWNLOAD_DOCUMENT': 'Datei konnte nicht heruntergeladen werden. Es ist ein Fehler aufgetreten',
      'ACCOUNT_TITLE_LOGIN': 'Zugang',
      'LOGIN_TITLE': 'Anmelden',
      'CONFIGURATION': 'Konfiguration',
      'LOGIN_USERNAME_LABEL': 'Username',
      'LOGIN_PASSWORD_LABEL': 'Passwort',
      'LOGIN_SUBMIT': 'Login',
      'LOGIN_VERSION_TITLE': 'Version',
      'Login.version': '1.0',
      'BUTT_PREFER_KA': 'Konzernabschluss entfernen',
      'BUTT_PREFER_EA': 'Einzelabschluss entfernen',
      'BUTT_PREFER_IRFS': 'IRFS entfernen',
      'BUTT_PREFER_IRFS_OLD': 'IFRS Alt entfernen',
      'BUTT_PREFER': 'Auswahl bevorzugen',
      'BUTT_CLOSE': 'Schliessen',
      'PREFER_TITLE_ABSCHLUSS': 'Abschlussart',
      'PREFER_TITLE_RECHTSKREIS': 'Rechtskreis',
      'TEXT_PREFERED_REMOVED': 'Einträge entfernt',
      'TITLE_ALL_DATA_IN_CURRENCY': 'Alle Werte in',
      'LABEL_PLZ_SELECT_PREFER': 'Auswahl bevorzugen',
      'TITLE_DOUBLE_ENTRIES_DIALOG': 'Doppelte Einträge sind vorhanden',
      'LABEL_PLZ_SELECT': 'Bitte auswählen',
      'EXPORT_EXCEL_STRUCT_BALANCE': 'Strukturbilanz',
      'EXPORT_EXCEL_PEERGROUP': 'Peergroup',
      'EXPORT_EXCEL_RAW_BALANCE': 'Rohbilanz',
      'BUTT_NAV_BACK': 'Zurück',
      'TITLE_SEARCH_BANK': 'Finanzinstitut suchen',
      'TITLE_SEARCH_PEERGROUP': 'Peergroup suchen 12345',
      'TITLE_EDIT_SEARCH_FIELDS': 'Suchfelder verwalten',
      'TITLE_BANK_HITLIST': 'Finanzinstitute gefunden:',
      'TITLE_SEARCH_FILTER_ADMIN': 'Suchfilter verwalten',
      'BUTT_OK': 'OK',
      'BUTT_SEARCH_FILTER_ADMIN': 'Suchfelder verwalten',
      'BUTT_SAVE_SEARCH': 'Suche speichern',
      'BUTT_DELETE_SEARCH': 'Suche löschen',
      'FINANCIAL_YEAR_BANK': 'Bilanzjahr der Ankerbank zzgl. Vorjahr',
      'SEARCH_MASK_NAME': 'Bitte geben Sie einen Namen für die Suchmaske ein',
      'BUTT_CANCEL': 'Abbrechen',
      'BUTT_SAVE': 'Speichern',
      'CURRENCY': 'Währung',
      'CURRENCY_DIMENSION': 'Währungsdimension',
      'dataSets': 'Datensätze',
      'peerGroup': 'Peergroup',
      'BUTT_SEARCH_BANK': 'Ankerbank suchen',
      'BUTT_EDIT_PEERGROUP': 'Peergroup bearbeiten',
      'BUTT_USE_BANK': 'Ankerbank übernehmen',
      'BUTT_FINISH_ANALYSIS': 'Analyse beenden',
      'WORD_OF': 'von',
      'SELECT_BANK': 'Bank auswählen',
      'PEEGROUP_ANALYSIS': 'Peergroup Analyse',
      'START_TEXT': 'Wie möchten Sie fortfahren?',
      'BUTT_BANK': 'Ankerbank',
      'BUTT_PEERGROUP_ANALYSIS': 'Peergroup Analyse',
      'TITLE_YOUR_PEERGROUP': 'Ihre Peergroup',
      'TITLE_PEERGROUP': 'Peergroup',
      'TEXT_ACTION': 'Aktion',
      'BUTT_ADD_BANK': 'Weiteres Finanzinstitut hinzufügen',
      'BUTT_START_PEERGROUP_ANALYSIS': 'Peergroup-Analyse starten',
      'TEXT_BANK_RESULT': 'Finanzinstitut Suchergebnis',
      'BUTT_ADD_TO_PEERGROUP': 'Zur Peergroup hinzufügen',
      'BUTT_RESTART': 'Neustart',
      'TC_COMP_LAST_YEAR': 'Vergleich Vorjahr <br> in %',
      'TC_PEERGROUP_MINIMUM': 'Minimum',
      'TC_PEERGROUP_MAX': 'Maximum',
      'TC_PEERGROUP_AVERAGE': 'Mittelwert',
      'TC_PEERGROUP_MEDIAN': 'Median',
      'TC_PEERGROUP_RANK': 'Rang in Peergroup',
      'TC_DATAFIELDS': 'Datenfelder<br>für Finanzinstitute',
      'TC_PEERGROUP_TITLE': 'Institute',
      'BUTT_EXPORT': 'Filterset downloaden',
      'DIALOG_TEXT_SUCCESS_IMPORT': 'Suchfilter wurde erfolgreich import.',
      'DIALOG_TEXT_FAILED_IMPORT': 'Suchfilter konnte nicht import werden.',
      'BUTT_IMPORT': 'Filterset hochladen',
      'BUTT_FILTERSET_DELETE': 'Filterset entfernen',
      'DIALOG_TEXT_SUCCESS_FILTER_SET_DELETED': 'Filterset wurde erfolgreich entfernt',
      'TITLE_CONFIG_FILTERSETS': 'Filtersets',
      'LABEL_SELECT_LINKS': 'Rohbilanz bearbeiten',
      'LABEL_ITEM_SELECT_0': 'Erfassung bearbeiten',
      'LABEL_ITEM_SELECT_1': 'Neues Bilanzjahr erfassen',
      'TITLE_SEARCH_HIDE_COLUMNS': 'Suchfelder einblenden',
      'LABEL_ALERT_ACTIVATED': 'Benachrichtigung',
      'LABEL_DOWNLOADS': 'Downloads',
      'TITLE_CHANGE_LOG': 'NewsBox',
      'CELL_TITLE_ABSCHLUSS': 'Abschlussart',
      'CELL_TITLE_NAME': 'Name',
      'CELL_TITLE_GRUND': 'Änderungsgrund',
      'CELL_TITLE_CREFONR': 'CrefoNR',
      'CELL_TITLE_QUELLE': 'Quelle',
      'CELL_TITLE_RECHTSKREIS': 'Rechtskreis',
      'CELL_TITLE_DATUM': 'Datum',
      'CELL_TITLE_DATE_ADDED': 'Hinzugefügt am',
      'CELL_TITLE_JAHR': 'Jahr',
      'CELL_TITLE_EMAIL': 'E-Mail',
      'BUTT_SUBMIT': 'Suchen',
      'BUTT_ADD_FAVOURITE_ADD': 'Zur Newsbox hinzufügen',
      'BUTT_ADD_FAVOURITE_REM': 'Aus Newsbox entfernen',
      'BUTT_EDIT_BILANZ': 'Bearbeiten',
      'BUTT_DOWNLOAD_BILANZ': 'Herunterladen',
      'BUTT_ADMIN_LOG': 'Admin Logging',
      'BUTT_CHANGES_LOG': 'Favoriten',
      'CELL_TITLE_ID': 'Id',
      'CELL_TITLE_TIME': 'Zeit',
      'CELL_TITLE_TYPE': 'Art',
      'CELL_TITLE_CLIENT_NR': 'ClientNr',
      'CELL_TITLE_FILE': 'Source',
      'CELL_TITLE_LINE': 'Zeile',
      'CELL_TITLE_TEXT': 'Text',
      'TITLE_ADMIN_LOG': 'Adminbereich Logging',
      'TABLE_ROWS_PER_PAGE': 'Einträge pro Seite',
      'TITLE_TABLE_CHANGE_LOG': 'Änderungen',
      'TITLE_TABLE_CHANGE_LOG_FAVOURITES': 'Favoriten',
      'CELL_TITLE_REGION': 'Region',
      'CELL_TITLE_LAND': 'Land',
      'CELL_TITLE_BRANCHE': 'Branche',
      'TABLE_CELL_TITLE_NEWSBOX': 'Newsbox',
      'CELL_TITLE_ACTION': 'Aktion',
      'CELL_TITLE_HGPNR': 'HGP-Nummer',
      'BUTT_NEWSBOX': 'Newsbox',
      'TABLE_LINE_TODAY': 'Heute',
      'TABLE_LINE_LAST_WEEK': 'letzte Woche',
      'TABLE_LINE_LAST_MONTH': 'letzter Monat',
      'TABLE_LINE_LATER': 'älter',
      'TABLE_CELL_ACTION_DELETE': 'Favorite entfernen',
      'TABLE_CELL_ACTION_EMAIL_NOTIFY': 'Email Benachrichtigung aktivieren',
      'FOOTER_MAILADDRESS': 'info@evaluerate.de',
      'FOOTER_TERMS_OF_USE': 'Nutzungsbedingungen',
      'FOOTER_LEGAL_NOTICE': 'Impressum',
      'FOOTER_LEGAL_NOTICE_URL': 'https://www.creditreform-rating.de/de/wir-ueber-uns/impressum.html',
      'FOOTER_DATA_PRIVACY': 'Datenschutz',
      'FOOTER_DATA_PRIVACY_URL': 'https://www.creditreform-rating.de/de/wir-ueber-uns/datenschutzerklaerung.html',
      'RESET_PASSWORD': 'Passwort zurücksetzen',
      'CURRENT_PASSWORD': 'Bisheriges Passwort',
      'NEW_PASSWORD': 'Neues Passowrt',
      'CONFIRM_NEW_PASSWORD': 'Neues Passwort bestätigen',
      'SUPPORT_TITLE': 'Ihr Kontakt zu uns',
      'TELEPHONE': '+49 (0) 21 31 / 109-626',
      'WELCOME_TEXT': 'Willkommen',
      'BUTT_NO_CUSTOMER': 'Noch kein Kunde?',
      'BUTT_FORGOT_PASSWORD': 'Passwort vergessen?',
      'TITLE_CONFIG_MODULE': 'Module Konfiguration',
      'DOWNLOAD_PDF_1': 'DOWNLOAD PDF 1',
      'DOWNLOAD_PDF_2': 'DOWNLOAD PDF 2',
      'DOWNLOAD_PDF_3': 'DOWNLOAD PDF 3',
      'SEARCHMASK_TITLE': 'Suchfelder aufklappen',
      'TAB_STAMMDATEN': 'Stammdaten',
      'TAB_STRUKTURBILANZ': 'Strukturbilanz',
      'TAB_ROHBILANZ': 'Rohbilanz',
      'TAB_KENNZAHLEN': 'Kennzahlen',
      'TAB_KAPITALDIENSTFAEHIGKEIT': 'Kapitaldienstfähigkeit',
      'TAB_BILANZRATING': 'Bilanzrating',
      'CHART_LABEL_BONIT': 'Entwicklung der Bilanzbonität',
      'TAB_DOKUMENTE': 'Dokumente',
      'TAB_STRUKTURBILANZ_AKTIVA': 'Aktiva',
      'TAB_STRUKTURBILANZ_GUV': 'GUV',
      'TAB_STRUKTURBILANZ_PASSIVA': 'Passiva',
      'TAB_STRUKTURBILANZ_SONSTIGE': 'Sonstige',
      'TAB_ROHBILANZ_AKTIVA': 'Aktiva',
      'TAB_ROHBILANZ_PASSIVA': 'Passiva',
      'TAB_ROHBILANZ_GUV': 'GUV',
      'TAB_ROHBILANZ_SONSTIGE': 'Sonstige',
      'BTN_CONFIG_SEARCH': 'Suchmaske konfigurieren',
      'BTN_CONFIG_LIST': 'Trefferliste konfigurieren',
      'TITLE_MISSING_MODULE': 'Fehlendes Modul',
      'BUTT_ADD': 'Hinzufügen',
      'BUTT_LOGOUT': 'Abmelden',
      'LABEL_CONFIG_DEFAULT': 'Standard',
      'LABEL_CONFIG_SELECTION': 'Konfiguration',
      'LABEL_CONFIG_NEW_ITEM': 'Neuer Eintrag',
      'LABEL_CONFIG_NAME': 'Konfigurationsname',
      'BTN_CONFIG_CREATE_NEW_ITEM': 'Neue Konfiguration',
      'LABEL_MODULE_ADMINISTRATION': 'Administration',
      'LABEL_MODULE_PASSWORD_RESET': 'Passwort zurücksetzen',
      'LABEL_MODULE_NEWSBOX': 'Newsbox',
      'DOWNLOAD_NAME_SB': 'Strukturbilanz Excel-Download',
      'DOWNLOAD_NAME_SD': 'Stammdaten Excel-Download',
      'DOWNLOAD_NAME_RB': 'Rohbilanz Excel-Download',
      'DOWNLOAD_NAME_KZ': 'Kennzahlen Excel-Download',
      'DOWNLOAD_NAME_KDF': 'Kapitaldienstfähigkeit Excel-Download',
      'DOWNLOAD_NAME_BR': 'Bilanzrating Excel-Download',
      'TITLE_KONFIGURATION': 'Konfigurations Filter:',
      'CHANGE_LOG_DOWNLOAD_DOC_TITLE_11': 'Offenlegungsbericht',
      'CHANGE_LOG_DOWNLOAD_DOC_TITLE_3': 'Jahresabschluss',
      'CELL_TITLE_BERICHT': 'Offenlegungsbericht',
      'REPORT_NEWSBOX_EXISTS': 'vorhanden',
      'REPORT_NEWSBOX_MISSING': 'nicht vorhanden',
      'DIALOG_CLOSE': 'schliessen',
      'LABEL_KEYWORD_OVERALLSEARCH': 'Suchwort',
      'DIALOG_TITLE_OVERALL_SEARCH': 'Allgemeine Suche',
      'DIALOG_TITLE_CONFIGURATION_NEW': 'Neue Konfiguration erstellen',
      'DIALOG_TITLE_CONFIGURATION_DELETE': 'Konfiguration entfernen',
      'LABEL_CONFIGURATION_DELETE_ITEM': 'Möchten Sie wirklich die Konfiguration {name} entfernen?',
      'LABEL_CONFIGURATION_NEW_DESCRIPTION': 'Bitte vergeben Sie dem Profil einen neuen Namen',
      'BUTT_TAKE_ANCHORBANK': 'Ankerbank übernehmen',
      'BUTT_TAKE_PEERGROUP': 'Peergroup bearbeiten',
      'BUTTON_FORWARD_TO_PGOVERVIEW': 'Peergroup Übersicht',
      'BUTT_DELETE_ITEM': 'Eintrag entfernen',
      'COMPANIES_TITLE': 'Unternehmen',
      'BANKS_TITLE': 'Banken',
      'INSURANCES_TITLE': 'Versicherungen',
      'BUTT_SEND': 'Abschicken',
      'BUTT_BACK': 'zurück',
      'SALUTION': 'Anrede,',
      'FORM_FORNAME': 'Vorname',
      'FORM_NAME': 'Nachname',
      'FORM_BUSINESS': 'Firma',
      'FORM_POSITION': 'Position',
      'FORM_ZIP': 'PLZ',
      'FORM_TOWN': 'Ort',
      'FORM_CONTACTME': 'Bitte kontaktieren Sie mich per …',
      'FORM_MAIL': 'E-Mail',
      'FORM_PHONENUMBER': 'Telefonnummer',
      'FORM_YOURMESSAGE': 'Ihre Nachricht',
      'FORM_MR': 'Herr',
      'FORM_MRS': 'Frau',
      'FORM_PHONE': 'Telefon',
      'FORM_MAILRULE': 'Bitte geben Sie eine gültige E-Mail Adresse ein',
      'TITLE_CONTACT': 'Kontaktieren Sie uns, um Ihre Zugangsdaten zu erhalten',
      'STAMM_CREFO': 'CrefoNr',
      'STAMM_ADDRESS': 'Adresse',
      'STAMM_COUNTRY': 'Land',
      'STAMM_REGION': 'Region',
      'STAMM_TAX': 'Steuernummer',
      'STAMM_SALESTAX': 'Ust-ID Nr.',
      'STAMM_LEI': 'LEI',
      'STAMM_BIC': 'BIC',
      'STAMM_LEGALFORM': 'Rechtsform',
      'STAMM_WZ': 'WZ-Code',
      'STAMM_TRADENAME': 'Branchenbezeichnung',
      'STAMM_FOUNDINGYEAR': 'Gründungsjahr',
      'STAMM_MOTHER': 'Ultimative Mutter',
      'STAMM_MOTHER_CREFO': 'CrefoNr ultimative Mutter',
      'STAMM_MOTHER_NAME': 'Name ultimative Mutter',
      'STAMM_PHONE': 'Telefon',
      'STAMM_FAX': 'Fax',
      'STAMM_MAIL': 'E-Mail',
      'STAMM_WEB': 'Internet',
      'STAMM_HEADLINE_EINS': 'Überschrift 1',
      'STAMM_HEADLINE_ZWEI': 'Überschrift 2',
      'STAMM_HEADLINE_DREI': 'Überschrift 3',
      'STAMM_HEADLINE_VIER': 'Überschrift 4',
      'STAMM_HEADLINE_FUENF': 'Überschrift 5',
      'TITLE_CURRENT_BALANCE_SHEET': 'Aktuelle Bilanzbonität',
      'TITLE_DEV_BALANCE_SHEET': 'Entwicklung der Bilanzbonität',
      'TITLE_KEY_DATA_BALANCE': 'Ratingrelevante Kennzahlen',
      'TAB_NEWSBOX_CHANGE': 'Änderungen',
      'TAB_NEWSBOX_FAV': 'Favoriten',
      'TITLE_DOCS_DOWNLOAD': 'Excel Dokumente zum herunterladen',
      'DOWNLOAD_STAMMDATEN': 'Stammdaten',
      'DOWNLOAD_STRUKTUR': 'StrukturBilanz',
      'DOWNLOAD_ROH': 'Rohbilanz',
      'DOWNLOAD_KENNZAHLEN': 'Kennzahlen',
      'DOWNLOAD_BILANZ': 'Bilanzrating',
      'DOWNLOAD_KDF': 'KDF',
      'DOWNLOAD_EXCEL': 'Excel-Dokument',
      'EMAIL_JA': 'Ja',
      'EMAIL_NEIN': 'Nein',
      'TITLE_DELETE_ALL': 'Alle {type} entfernen',
      'QUESTION_DELETE_ALL': 'Möchten Sie alle {type} wirklich entfernen?',
      'BUTT_DELETE_STOP': 'Nichts machen',
      'BUTT_DELETE_ALL': 'Alle entfernen',
      'TITLE_DELETE_ITEM': 'Eintrag löschen {type} {id}',
      'QUESTION_DELETE_ITEM': 'Möchten Sie diesen Eintrag wirklich löschen?',
      'BUTT_DELETE_ITEM_STOP': 'Nicht löschen',
      'TEST_MISSING_MODULE': 'Fehlendes Modul',
      'LABEL_FILTER': 'Filter',
      'TAB_EASY': 'Einfach',
      'TAB_ADVANCED': 'Erweitert',
      'TAB_ADMIN': 'Verwaltung',
      'HEADERS_DIALOG_SEARCH_NAME': 'Name',
      'HEADERS_DIALOG_SEARCH_TYP': 'Type',
      'HEADERS_DIALOG_SEARCH_UNITY': 'Einheit',
      'LABEL_SEARCHMASKNAME': 'Name für Suchmaske',
      'ALERT_SEARCHMASK': 'Name existiert bereits. Bitte verwenden Sie einen anderen Name.',
      'LABEL_SITEM_FROM': 'von',
      'LABEL_SITEM_TO': 'bis',
      'LABEL_IFRS': 'IFRS',
      'LABEL_IFRS_ALT': 'IFRS Alt',
      'TOOLTIP_DELETE': 'Entfernen',
      'TITLE_HIT_LIST_CONFIG': 'Trefferliste konfigurieren {idModule}',
      'TITLE_HIT_LIST_FIELDS': 'Trefferlisten Felder',
      'BUTT_HIT_LIST_ADD': 'Hinzufügen',
      'HEADER_HIT_LIST_ID': 'ID',
      'HEADER_HIT_LIST_NAME': 'Name',
      'HEADER_HIT_LIST_TYPE': 'Type',
      'HEADER_HIT_LIST_WIDTH': 'Breite',
      'TITLE_SEARCHMASK_CONFIG': 'Suchmaske konfigurieren {idModule}',
      'TITLE_SEARCHMASK_FIELDS': 'Suchmasken Felder',
      'BUTT_RESET_PASSWORD': 'Passwort setzen',
      'TITLE_PASSWORD_REQUIRED': 'Eingabe erforderlich',
      'TITLE_PASSWORD_RULES': 'Name must be less than 10 characters',
      'LABLE_SEARCH': 'Suchen',
      'ALERT_NO_RESULTS': 'Keine Treffer für crefoNr ',
      'FORM_REQUIRED': 'Eingabe erforderlich',
      'CHECKBOX_LEGALNOTICE1': 'Ich habe die',
      'LEGALNOTICE': 'Datenschutzerklärung',
      'CHECKBOX_LEGALNOTICE2': 'der Creditreform Rating AG gelesen und bin mit dieser einverstanden. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden. Hinweis: Sie können Ihre Einwilligung jederzeit für die Zukunft per E-Mail an',
      'EMAIL_LEGALNOTICE': 'info@creditreform-rating.de',
      'CHECKBOX_LEGALNOTICE3': 'widerrufen.',
      'TOOLTIP_LEGALNOTICE': 'Datenschutzerklärung im neuen Fenster öffnen',
      'TITLE_DIALOG_SENDMAIL': 'Ihre E-Mail wurde gesendet',
      'TEXT_DIALOG_SENDMAIL': 'Ihre E-Mail wurde erfolgreich gesendet. Wir werden uns in Kürze bei Ihnen melden',
      'BUTT_USE': 'anwenden',
      'BUTT_BACK_LOGIN': 'Zurück zum Login',
      'BUTT_DIALOG_LEAVE_TITLE': 'Peergroup verlassen',
      'BUTT_DIALOG_LEAVE_TEXT': 'Möchten Sie die Peergroup wirklich verlassen?',
      'BUTT_DIALOG_LEAVE_PEERGROUP': 'Peergroup verlassen',
      'TITLE_CONTACT_SUPPORT': 'Support kontaktieren',
      'SUBTITLE_CONTACT_SUPPORT': 'Bitte wählen Sie ein Themengebiet aus zu dem Sie Support benötigen und geben dann Ihre Nachricht ein.',
      'SUBJECT': 'Themengebiete',
      'SUBJECT_PASSWORD_FORGOT': 'Passwort vergessen',
      'TITLE_PASSWORD_FROGOT': 'Sie haben Ihr Passwort vergessen',
      'SUBJECT_MATTER': 'Betreff',
      'BUTT_CHANGE_WA': 'Abschluss wechseln',
      'SUBTITLE_CONTACT_SUPPORT_UPLOAD': 'Fehlenden Jahresabschluss hochladen',
      'UPLOAD_SELECT': 'Datei auswählen',
      'RADIO_PRIAVTE': 'Nicht öffentlich',
      'RADIO_PUBLIC': 'öffentlich',
      'BUTT_SUBMIT_EXCEL': 'Excelexport',
      'PASSWORD_MISSMATCH_TITLE': 'Passwort Validierung',
      'PASSWORD_MISSMATCH': 'Passwort und Passwort Bestätigung stimmen nicht überein.',
      'PASSWORD_LENGTH': 'Passwort muss mindestens 8 Zeichen haben und aus Großbuchstaben, Kleinbuchstaben und Sonderzeichen oder Zahlen bestehen',
      'BUTT_LOAD_PEERGROUP': 'Peergroup laden',
      'BUTT_SAVE_PEERGROUP': 'Peergoup speichern',
      'BUTT_OPTIMIZE_PEERGROUP': 'Peergroup aktualisieren',
      'PEERGROUP_TITLE_SAVE': 'Benennen Sie Ihre Peergroup',
      'TITLE_PEERGROUP_LOAD': 'Peergroup laden',
      'BUTT_LOAD': 'Laden',
      'LABLE_LOAD_PEERGROUP': 'gespeicherte Peergroups',
      'MENU_CHANGE_PASSWORD': 'Passwort ändern',
      'MENU_ADMINISTRATION': 'Administration',
      'MENU_DASHBOARD': 'Dashboard',
      'MENU_NEWSBOX': 'Newsbox',
      'SEARCH_TITLE': 'Suche',
      'PEERGROUP_TITLE': 'Peergroup',
      'NEWSBOX_TITLE': 'Newsbox',
      'CONFIGURATION_TITLE': 'Konfiguration',
      'TOOLTIP_CURRENCY': 'Konfiguration Währung',
      'TITLE_DIM_SELECTION': 'Währung wählen',
      'TAB_BANKSCORE': 'Bankenscore',
      'BUTT_WITHOUT_BAL': 'Ohne Jahresabschluss fortfahren',
      'TAB_VERFLECHTUNG': 'Verflechtung',
      'LABEL_PEERGROUPNAME': 'Name',
      'LOGIN_FAILED_TITLE': 'Anmeldungsfehler',
      'LOGIN_FAILED_DESCRIPTION': 'Ein Fehler ist aufgetreten, bitte wenden Sie sich an den Support.',
      'JSON_FAILED_TITLE': 'Anwendungsfehler',
      'JSON_FAILED_DESCRIPTION': 'In der Anwendung ist ein Fehler aufgetreten.',
      'TITLE_PEERGROUP_INSTITUTES': 'Institute',
      'TITLE_DIALOG_SEARCH_MASK_CONFIG': 'Suchmaske verwalten',
      'SUPPORT_SUBJECT_1': 'Thema Eins',
      'SUPPORT_SUBJECT_2': 'Thema Zwei....',
      'LABEL_PREFER_KONZERNAB': 'Konzernabschluss',
      'LABEL_PREFER_EINZELAB': 'Einzelabschluss',
      'TITLE_CONTACT_SUPPORT_MAIL_SEND': 'Ihre E-Mail wurde erfolgreich versendet',
      'SUBTITLE_CONTACT_SUPPORT_MAIL_SEND': 'Ihre Anfrage wird bearbeitet. Die Creditreform Rating AG wird sich mit Ihnen in Verbindung setzen.',
      'MISSING_BALANCE_TITLE': 'Fehlenden Jahresabschluss melden',
      'TITLE_CONTACT_SUPPORT_MISSING_BALANCE': 'Sie haben einen fehlenden Jahresabschluss?',
      'SUBTITLE_UPLOAD_MISSING_BALANCE': 'Bitte laden Sie den fehlenden Jahresabschluss hoch',
      'SUPPORT_SUBJECT_UPLOAD': 'Fehlenden Abschluss für Nummer ',
      'TITLE_PEERGROUP_SELECT_FILTERS': 'Bitte wählen Sie ihre Kriterien und klicken Sie danach auf "Suchen"',
      'HITLIST_COUNTER': 'Anzahl Treffer: {counter}',
      'TOOLTIP_OPEN_SEARCHMASK': 'Suchmaske aufklappen',
      'TOOLTIP_CLOSE_SEARCHMASK': 'Suchmaske einklappen',
      'TITLE_DOCUMENT_DOWNLOAD_PEERGROUP': 'Peegroup',
      'TITLE_DOCUMENT_DOWNLOAD': 'Unternehmensakte',
      'TABLE_SELECTION_COUNT': 'Ausgewählt',
      'TAB_FILTER_CONFIG_NM': 'Nicht Monetäre Daten',
      'TAB_FILTER_CONFIG_SP': 'Strukturpositionen',
      'TAB_FILTER_CONFIG_KZ': 'Kennzahlen',
      'COMPANIES_SEARCH_TITLE': 'Suche',
      'COMPANIES_PEERGROUP_TITLE': 'Peergroup',
      'COMPANIES_NEWSBOX_TITLE': 'Newsbox',
      'COMPANIES_CONFIGURATION_TITLE': 'Konfiguration',
      'INSURANCES_SEARCH_TITLE': 'Suche',
      'INSURANCES_PEERGROUP_TITLE': 'Peergroup',
      'INSURANCES_NEWSBOX_TITLE': 'Newsbox',
      'INSURANCES_CONFIGURATION_TITLE': 'Konfiguration',
      'BANKS_SEARCH_TITLE': 'Suche',
      'BANKS_PEERGROUP_TITLE': 'Peergroup',
      'BANKS_NEWSBOX_TITLE': 'Newsbox',
      'BANKS_CONFIGURATION_TITLE': 'Konfiguration',
      'BANKENSCORE_NAME': 'Name: ',
      'BANKENSCORE_YEAR': 'Abschlussjahr:',
      'BANKENSCORE_WA': 'Abschluss:',
      'BANKENSCORE_RECHTSKREIS': 'Rechtskreis:',
      'BUTT_CLOSE_PEERGROUP': 'Peergroup beenden',
      'BUTT_ADD_BANK_COMPANIES': 'Unternehmen hinzufügen',
      'BUTT_ADD_BANK_BANKS': 'Finanzinstitute hinzufügen',
      'BUTT_ADD_BANK_INSURANCES': 'Versicherung hinzufügen',
      /*ab hier*/
      'BILANZRATING_NAME': 'Name der Mutter:',
      'FORM_MESSAGE_PASSWORD_FORGOT': 'Bitte setzen Sie mein Passwort zurück.',
      'TITLE_CONFIG_MODULE_COMPANIES': 'Konfiguration Unternehmen',
      'TITLE_CONFIG_MODULE_BANKS': 'Konfiguration Banken',
      'TITLE_CONFIG_MODULE_INSURANCES': 'Konfiguration Versicherungen',
      'TITLE_CONFIG_SEARCH_COMPANIES': 'Unternehmenssuche',
      'TITLE_CONFIG_SEARCH_BANKS': 'Bankensuche',
      'TITLE_CONFIG_SEARCH_INSURANCES': 'Versicherungensuche',
      'TITLE_CONFIG_PEERGROUP_COMPANIES': 'Peergroupsuche Unternehmen',
      'TITLE_CONFIG_PEERGROUP_BANKS': 'Peergroupsuche Banken',
      'TITLE_CONFIG_PEERGROUP_INSURANCES': 'Peergroupsuche Versicherungen',
      'TITLE_CONFIG_SEARCH_ADMIN_COMPANIES': 'Unternehmenssuche Admin Standard',
      'TITLE_CONFIG_SEARCH_ADMIN_BANKS': 'Bankensuche Admin Standard',
      'TITLE_CONFIG_SEARCH_ADMIN_INSURANCES': 'Versicherungensuche Admin Standard',
      'TITLE_CONFIG_PEERGROUP_ADMIN_COMPANIES': 'Peergroupsuche Unternehmen Admin Standard',
      'TITLE_CONFIG_PEERGROUP_ADMIN_BANKS': 'Peergroupsuche Banken Admin Standard',
      'TITLE_CONFIG_PEERGROUP_ADMIN_INSURANCES': 'Peergroupsuche Versicherungen Admin Standard',
      /*oben die hat michael schon*/
      'TITLE_CHOOSE_YEAR': 'Bitte wählen Sie ein Jahr aus',
      'TITLE_SEARCH_PEERGROUP_COMPANIES': 'Peergroup suchen',
      'TITLE_SEARCH_PEERGROUP_BANKS': 'Peergroup suchen',
      'TITLE_SEARCH_PEERGROUP_INSURANCES': 'Peergroup suchen',
      'SEARCHMASK_TITLE_COMPANIES': 'Unternehmen suchen',
      'SEARCHMASK_TITLE_BANKS': 'Finanzinstitut suchen',
      'SEARCHMASK_TITLE_INSURANCES': 'Versicherung suchen',
      'COL_CONFIG': 'Spalten konfigurieren',
      'COL_CONFIG_DES': 'Hier können Sie die spalten konfigurieren',
      /* müsste Michael noch nicht haben*/
      'BUTT_CLEAR_SEARCH': 'Suchmaske zurücksetzen',
      'CHANGELOG_TITLE': 'Was gibt es neues?',
      /*hat michael bekommen*/
      'TITLE_PEERGROUP_INSTITUTES_COMPANIES': 'Unternehmen',
      'TITLE_PEERGROUP_INSTITUTES_BANKS': 'Finanzinstitute',
      'TITLE_PEERGROUP_INSTITUTES_INSURANCES': 'Versicherungen',
      'MISSING_ANNUAL': 'Es fehlt der Abschluss für',
      'BUTT_OPTIMIZE_PG_TAKE': 'Auswahl übernehmen',
      'BUTT_OPTIMIZE_CANCEL': 'Vorgang abbrechen',
      /*Button Finanzjahr*/
      'FINANCIAL_YEAR_BANK_COMPANIES': 'Bilanzjahr Basisunternehmen zzgl. Vorjahr',
      'FINANCIAL_YEAR_BANK_BANKS': 'Bilanzjahr Basisbank zzgl. Vorjahr',
      'FINANCIAL_YEAR_BANK_INSURANCES': 'Bilanzjahr Basisversicherung zzgl. Vorjahr',
      'PDF_BILANZ_REPORT_FILENAME': 'Bilanzreport',
      'TEXT_STAMMDATA_NOT_SHOWN': 'Aufgrund der hohen Anzahl von Finanzinstituten werden keine Stammdaten angezeigt.',
      'IDLE_MESSAGE_BIG_DATA': 'Diese Daten können ein wenig Zeit in Anspruch nehmen',
      'MISSING_BALANCE_TOOLTIP': 'Fehlenden Jahresabschluss melden',
      'DOWNLOAD_PG2BILANZ': 'PG2 Bilanz',
      'TAB_VERFLECHTUNG_DOWNLOAD': 'Verflechtung',
      'titleSuccessResetPasswordDialog': 'Erfolgreich',
      'titleSuccessResetPasswordText': 'Das Passwort wurde erfoglreich verändert.',
      'PDF_FS_REPORT_FILENAME': 'Jahresabschluss',
      'PDF_DCR_REPORT_FILENAME': 'Offenlegungsbericht',
      'TITLE_DOCS_DOWNLOAD_PDF': 'PDF Dokumente herunterladen',
      'TITLE_PASSWORD_FORGOT': 'Passwort vergessen',
      'TEXT_DIALOG_SENDMAIL_REGISTER': 'Registrierung wurde versendet',
      'TITLE_REGISTER_SEND': 'Sie erhalten in Kürze eine E-Mail',
      'LABLE_SEARCH_HITLIST': 'Suche Trefferliste',
      'LABLE_SEARCH_SEARCHMASK': 'Suche Suchmaske',
      //von Rebecca 27.04.
      'DIALOG_WZ_CODE_TITLE': 'WZ Code wählen',
      'BUTTON_WZ_CODE_OPEN' : 'WZ Code suchen',
      'LABEL_WZ_CODE': 'WZ Code',
      'LABEL_WZ_CODE_SELECT': 'Bitte wählen Sie zuerst einen Bereich aus',
      'RESULT_EMPTY_OVERALL_SEARCH': 'Keine Treffer gefunden',
      'BASCO_BAD_SCORE': 'schlechter Bankenscore',
      'BASCO_GOOD_SCORE': 'guter Bankenscore',
      'TITLE_CHECKBOX_WO_BALANCE': 'Einträge ohne Abschluss anzeigen',
      'TAB_DISABLED_CAUSE_NO_DATA': 'Keine Daten vorhanden',
      'TAB_DISABLED_CAUSE_NO_LICENSE': 'Keine Lizenz vorhanden',
      'TAB_DISABLED_CAUSE_NO_BALANCE': 'Keine Abschluss gewählt',
      'TOOLTIP_NO_BALANCE_DATA': 'Kein Abschluss vorhanden',
      'RESET_PASSWORD_EXPIRES': 'Passwort zu alt, bitte neu setzen',
      'HEADER_HIT_LIST_DIMENSION': 'Währungsdimension',
      'LABEL_SITEM_IN': 'in',
      'TEXT_PASSWORD_SPECIFICATION': 'Das Passwort muss aus mindestens acht und maximal 30 Zeichen bestehen.\n' +
        'Das Passwort muss mindestens drei Elemente der folgenden Zeichengruppen beinhalten:\n' +
        'Großbuchstaben [A-Z]\n' +
        'Kleinbuchstaben [a-z]\n' +
        'Ziffern [0-9]\n' +
        'Sonderzeichen [!@#$%^&*(),.]',
      'TOOLTIP_RING_GOOD': 'hervorragende Bonität',
      'TOOLTIP_RING_BAD': 'schwache Bonität',
      'TOOLTIP_CRAS': 'CRAS  Country Risk Assessment Score\n\nCRAS steht für Country Risk Assessment Score. Der CRAS ist ein Risikomaß, das Werte zwischen 1 und 10 annehmen kann und sich auf das Geschäftsumfeld bzw. Kreditnehmer/Geschäftspartner in einem bestimmten Land bezieht. So gibt er Auskunft über Länderrisiken im Auslandsgeschäft und stellt zudem einen guten Indikator für das länderspezifische Ausfallrisiko dar. Der CRAS basiert auf der etablierten und international anerkannten Länderrating-Methodik der Creditreform Rating. Dabei profitiert der CRAS nicht zuletzt von der Expertise der Analysten, die in ständigem fachlichen Diskurs mit den für Länderratings zuständigen Behörden in den von Creditreform Rating gerateten Ländern stehen.',
      'TITLE_CONFIG_GLOBAL_SEARCH_BANKS': 'Globale Suche für Banken',
      'TITLE_CONFIG_GLOBAL_SEARCH_COMPANIES': 'Globale Suche für Unternehmen',
      'TITLE_CONFIG_GLOBAL_SEARCH_ADMIN_BANKS': 'Globale Suche Admin für Banken',
      'TITLE_CONFIG_GLOBAL_SEARCH_ADMIN_COMPANIES': 'Globale Suche Admin für Unternehmen',
      'TITLE_CONFIG_GLOBAL_SEARCH_SADMIN_BANKS': 'Globale Suche Super Admin für Banken',
      'TITLE_CONFIG_GLOBAL_SEARCH_SADMIN_COMPANIES': 'Globale Suche Super Admin für Unternehmen',
      'TITLE_CONFIG_SEARCH_SADMIN_BANKS': 'Bankensuche Super Admin Standard',
      'TITLE_CONFIG_SEARCH_SADMIN_INSURANCES': 'Versicherungensuche Super Admin Standard',
      'TITLE_CONFIG_PEERGROUP_SADMIN_COMPANIES': 'Peergroupsuche Unternehmen Super Admin Standard',
      'TITLE_CONFIG_PEERGROUP_SADMIN_BANKS': 'Peergroupsuche Banken Super Admin Standard',
      'TITLE_CONFIG_PEERGROUP_SADMIN_INSURANCES': 'Peergroupsuche Versicherungen Super Admin Standard',
      'LABEL_DD_ALL': 'Alle',
      //von Rebecca 21.09.2020
      'COMPANIES_ANKERBANK_DETAIL': 'Ankerunternehmen',
      'BANKS_ANKERBANK_DETAIL': 'Ankerbank',
      'INSURANCES_ANKERBANK_DETAIL': 'Versicherungen',
      'COMPANIES_ANKERBANK_DETAIL_YEAR': 'Jahr',
      'BANKS_ANKERBANK_DETAIL_YEAR': 'Jahr',
      'INSURANCES_ANKERBANK_DETAIL_YEAR': 'Jahr',
      'COMPANIES_ANKERBANK_DETAIL_JURISDICTION': 'Rechtskreis',
      'BANKS_ANKERBANK_DETAIL_JURISDICTION': 'Rechtskreis',
      'INSURANCES_ANKERBANK_DETAIL_JURISDICTION': 'Rechtskreis',
      // von Rebecca 22.09.2020
      'NAME_BANK_TABLE': 'Name der Bank',
      'CREFO_BANK_TABLE': 'CrefoNummer',
      'DIALOG_TITLE_MISSING_HAS_EXPORT': 'Recht fehlt',
      'DIALOG_TEXT_MISSING_HAS_EXPORT': 'Sie haben nicht das Recht Dokumente herunterzuladen',
      'TITLE_DOCS_DOWNLOAD_EXPORT_FORMATS': 'Weitere Exportformate für Rohbilanz',
      'SWITCH_ADD_ANKER_INTO_PG': 'Basisbank in Peergroup einbeziehen',
      'PDF_AX_WORD_FILENAME': 'Bilanzkommentierung',
      //von Rebecca 06.10.2020
      'TITLE_FORMEL': 'Kennzahlenformel',
      'TITLE_ENDFORMEL': 'Endformel',
      'LABEL_PEERGROUP_CNT': 'In Peergroup:',
      'SORT_PERCENTAGE': 'Anteile',
      'SORT_NAME': 'Name',
      'LABEL_SORTING': 'Sortierung',
      'TITLE_BC_COMMENT': 'Bilanzkommentar',
      'TITLE_EF_COMMENT': 'Erfassungsformel',
      'TOOLTIP_KZF': 'Kennzahl Formel anzeigen',
      'TOOLTIP_KZF_INFO': 'Kennzahl Formel anzeigen',
      'LABEL_DEEP_VALUES': 'Verschachtelungstiefe',
      'BANKS_TITLE_CHECKBOX_WO_BALANCE': 'auch Banken ohne Bilanz suchen',
      'LABEL_VIEW_FORMULAS': 'Formel',
      'CONFIGURATION_QUESTION': 'Möchten Sie eine bestehende Konfiguration anpassen oder eine neue erstellen?',
      'BUTT_EDIT_ALREADY_CREATE': 'Bestehende anpassen',
      'BUTT_CREATE_NEW_CONFIG': 'Neue Konfiguration',
      'TOOLTIP_REMOVE_CONFIGURATION': 'Konfiguration entfernen',
      'DIALOG_TITLE_MISSING_BALANCE': 'Abschluss fehlt',
      'DIALOG_TEXT_MISSING_BALANCE': 'Hierzu gibt es keinen Abschluss',
      'DOWNLOAD_REPORT_TITLE': 'Bilanzrating',
      'DIALOG_LOGIN_FAILED_TITLE': 'Fehler',
      'DIALOG_LOGIN_FAILED_TITLE_WRONG_PASSWORD': 'Passwort falsch',
      'LOGIN_FAILED_DESCRIPTION_WRONG_PASSWORD': 'Die Kombination von Benutzername und Passwort existiert nicht. Bitte prüfen Sie Ihre Eingabe.',
      'DIALOG_LOGIN_FAILED_TITLE_DISABLE': 'User gesperrt',
      'LOGIN_FAILED_DESCRIPTION_DISABLE': 'Ihr Zugang ist gesperrt. Bitte wenden Sie sich an den Support.',
      'SWITCH_ADD_ANKER_INTO_PG_COMPANIES':'SWITCH_ADD_ANKER_INTO_PG_COMPANIES',
      'SWITCH_ADD_ANKER_INTO_PG_BANKS':'SWITCH_ADD_ANKER_INTO_PG_BANKS',
      'SWITCH_ADD_ANKER_INTO_PG_INSURANCES':'SWITCH_ADD_ANKER_INTO_PG_INSURANCES',
      'EMAIL_SUPPORT': 'support@ticket.creditreform-rating.de',
      'EMAIL_SUPPORT_COMPANIES':'',
      'EMAIL_SUPPORT_BANKS':'',
      'EMAIL_SUPPORT_INSURANCES':'',
      'EMAIL_SUPPORT_BALANCE_COMPANIES':'',
      'EMAIL_SUPPORT_BALANCE_BANKS':'',
      'EMAIL_SUPPORT_BALANCE_INSURANCES':'',
      'ERROR_FORMAT_DOES_NOT_MATCHDDMMYYYY': 'Datumsformat prüfen'
    },
    'translationsEn': {
      'FOOTER_LEGAL_NOTICE': 'Imprint',
      'FOOTER_LEGAL_NOTICE_URL': 'https://www.creditreform-rating.de/en/about-us/legal-notice.html',
      'FOOTER_DATA_PRIVACY': 'Data protection',
      'FOOTER_DATA_PRIVACY_URL': 'https://www.creditreform-rating.de/en/about-us/data-protection-declaration.html',
      'DIALOG_LOGIN_FAILED_TITLE':'Error',
      'DIALOG_LOGIN_FAILED_TITLE_DISABLE':'User blocked',
      'DIALOG_LOGIN_FAILED_TITLE_WRONG_PASSWORD': 'Wrong password',
      'LOGIN_FAILED_DESCRIPTION':'An error has occurred, please contact support.',
      'LOGIN_FAILED_DESCRIPTION_DISABLE':'Your user is blocked, please contact support.',
      'LOGIN_FAILED_DESCRIPTION_WRONG_PASSWORD':'The combination of username an password is not valid. Please check your entry.',
      'ERROR_FORMAT_DOES_NOT_MATCHDDMMYYYY': 'Date format does not match'
    }
  }
}
export default MyI18NLoader



// WEBPACK FOOTER //
// ./src/components/I18N/i18n.js